var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLampIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.178,
    height: 16.663,
    viewBox: "0 0 17.178 16.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11514",
    "data-name": "Group 11514",
    transform: "translate(-139.727 -167.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    transform: "translate(143.791 171.302)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.742,
    cy: 4.742,
    r: 4.742,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.742,
    cy: 4.742,
    r: 4.242,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29570",
    "data-name": "Path 29570",
    d: "M961,643.853v-4.107h5.211v4.107",
    transform: "translate(-815.266 -471.268)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29571",
    "data-name": "Path 29571",
    d: "M948.885,644.346l1.9,1.987",
    transform: "translate(-806.641 -474.543)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29572",
    "data-name": "Path 29572",
    d: "M940.145,666h2.694",
    transform: "translate(-800.418 -489.961)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29573",
    "data-name": "Path 29573",
    d: "M948.885,682.5l1.766-1.811",
    transform: "translate(-806.641 -500.42)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29574",
    "data-name": "Path 29574",
    d: "M970.046,689.318v-2.65",
    transform: "translate(-821.708 -504.678)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29575",
    "data-name": "Path 29575",
    d: "M986.885,682.281l-1.811-1.9",
    transform: "translate(-832.408 -500.201)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29576",
    "data-name": "Path 29576",
    d: "M993.135,666h-2.694",
    transform: "translate(-836.23 -489.961)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29577",
    "data-name": "Path 29577",
    d: "M986.557,644.346l-1.943,1.987",
    transform: "translate(-832.081 -474.543)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampIcon);
export default __webpack_public_path__ + "static/media/LampIcon.b564747bab1713c9268783e23dbe91b9.svg";
export { ForwardRef as ReactComponent };